export const PROJECT_STATUS: {
  [key in ProjectStatus]: {
    id: string
    title: string
    client_title: string
    color: string
  }
} = {
  fresh: {
    id: 'fresh',
    title: 'Fresh',
    client_title: 'Yet to Start',
    color: 'blue'
  },
  writing_progress: {
    id: 'writing_progress',
    title: 'Creation Progress',
    client_title: 'In Progress (Writing)',
    color: 'orange'
  },
  editing_progress: {
    id: 'editing_progress',
    title: 'Editing Progress',
    client_title: 'In Progress (Editing)',
    color: 'orange'
  },
  completed: {
    id: 'completed',
    title: 'Completed',
    client_title: 'Completed',
    color: 'cyan'
  },
  closed: {
    id: 'closed',
    title: 'Closed',
    client_title: 'Closed',
    color: 'green'
  },
  scrapped: {
    id: 'scrapped',
    title: 'Scrapped',
    client_title: 'Scrapped',
    color: 'red'
  },
  hold: {
    id: 'hold',
    title: 'On Hold',
    client_title: 'On Hold',
    color: 'magenta'
  }
}
